import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { ESignatureComponent } from './components/e-signature/e-signature.component';
import { AuthGuard } from './core/guards/auth-guard.service';
import { ESignatureGuard } from './core/guards/e-signature-guard.service';
import { DomainGuard } from './core/guards/domain.guard';
import { GroupPermissionsType } from './shared/group-permissions-type.enum';
import { PermissionGuard } from './core/guards/permission-guard.service';

const routes: Routes = [
    {
        path: '',
        canActivate: [DomainGuard],
        loadChildren: () => import('@cl/pages/pages.module').then((m) => m.PagesModule),
    },
    {
        path: 'auth',
        loadChildren: () => import('@cl/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'work-timer',
        canActivate: [AuthGuard, DomainGuard, PermissionGuard],
        data: {
            permissions: [GroupPermissionsType.WORK_TIME_VIEW],
        },
        loadChildren: () => import('@cl/work-timer/work-timer.module').then((m) => m.WorkTimerModule),
    },
    {
        path: 'e-signature',
        component: ESignatureComponent,
        canActivate: [ESignatureGuard, AuthGuard],
    },
    {
        path: '404',
        component: NotFoundComponent,
    },
    { path: '**', redirectTo: '/404' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
